// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"bdd3d561","239":"bdd3d561","351":"bdd3d561","812":"1890daff"}[chunkId] + ".chunk.css";
};